"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineRentersClaimRequest = void 0;
const OnlineClaimRequest_1 = require("../OnlineClaimRequest");
class OnlineRentersClaimRequest extends OnlineClaimRequest_1.OnlineClaimRequest {
    constructor(init) {
        super();
        Object.assign(this, init);
    }
}
exports.OnlineRentersClaimRequest = OnlineRentersClaimRequest;
//# sourceMappingURL=OnlineRentersClaimRequest.js.map